import * as yup from "yup";

export const DEFAULT_VALUES = {
	type: "",
	Username: "",
	Email: "",
	Password: "",
	ConfirmPassword: "",
	otp: "",
	sessionUserAttributes: "",
}